var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6 0.000488281C2.6916 0.000488281 0 2.69198 0 6.00016C0 9.30842 2.6916 11.9999 6 11.9999C9.3084 11.9999 12 9.30842 12 6.00016C12 2.69198 9.3084 0.000488281 6 0.000488281ZM6 10.909C3.29313 10.909 1.09091 8.70692 1.09091 6.0002C1.09091 3.29347 3.29313 1.0914 6 1.0914C8.70687 1.0914 10.9091 3.29347 10.9091 6.00016C10.9091 8.70696 8.70687 10.909 6 10.909Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99956 4.72754C5.69832 4.72754 5.4541 4.97176 5.4541 5.27299V8.90874C5.4541 9.20998 5.69832 9.45419 5.99956 9.45419C6.30079 9.45419 6.54501 9.20998 6.54501 8.90874V5.27299C6.54501 4.97179 6.30079 4.72754 5.99956 4.72754Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99956 2.5459C5.85592 2.5459 5.71552 2.60408 5.61374 2.70553C5.51228 2.80699 5.4541 2.94772 5.4541 3.09135C5.4541 3.23499 5.51228 3.37535 5.61374 3.47717C5.71519 3.57863 5.85592 3.63681 5.99956 3.63681C6.14319 3.63681 6.28356 3.57863 6.38534 3.47717C6.48679 3.37535 6.54501 3.23499 6.54501 3.09135C6.54501 2.94772 6.48679 2.80699 6.38534 2.70553C6.28356 2.60404 6.14319 2.5459 5.99956 2.5459Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.78487b37cfe416d9bf84f2e27f43cc47.svg";
export { ForwardRef as ReactComponent };